export default {
  hordeEnergyToStr: '+{0} Stärke pro aktueller Energie',
  hordeEnergyToEnergyReg: '+{0} Energieregeneration pro fehlender Energie',
  hordeManaToHaste: '+{0} Eile pro aktuellem Mana',
  hordeEnergyOnCrit: '+{0} Energie beim kritischen Treffer',
  hordeHealOnCrit: 'Heilt {0} der maximalen Leben beim kritischen Treffer',
  hordeRestoreCooldownOnCrit: 'Reduziert Abklingzeiten um {0} beim kritischen Treffer',
  hordeBloodOnCrit: 'Erhalte {0} vom gegnerischen Blut beim kritischen Treffer',
  hordeManaRest: 'Erhalte {1} Manaregeneration, wenn {0} keine aktiven Fähigkeiten benutzt werden',
  hordeManasteal: 'Erhalte {0} Mana pro getöteten Gegner',
  hordePassiveRecovery: 'Wende {0} der Erholung jede Sekunde an',
  hordeActiveDamageCrit: 'Aktive Fähigkeiten mit Schaden können mit {0} Effizienz kritisch treffen',
  hordeActiveHealCrit: 'Aktive Fähigkeiten mit Heilung können mit {0} Effizienz kritisch treffen',
  hordeFirstStrikeStun: 'Der Erstschlag betäubt auch für {0}',
  hordeSpellbladeOnActive: 'Aktive Ausrüstungseffekte lösen Zauberklinge {0} Mal mehr aus',
  hordeCritOnNonCrit: 'Erhalte +{0}* kritische Chance, wenn dein normaler Angriff nicht kritisch trifft. Das kann mehrfach passieren, setzt sich aber zurück, sobald du kritisch triffst',
  hordeStunOnCrit: 'Kritische Treffer haben eine 5% Chance für {0} zu betäuben',
  hordeReviveDivisionShield: 'Stelle {0} von deinem Teilungsschild wieder her, wenn du wiederbelebt wirst',
  hordeReduceAttackOnAttack: 'Reduziere den gegnerischen Angriff um {0} bei einem normalen Angriff, bis zu {1} Mal',
  hordeAttackAfterTime: 'Erhalte +{0} Angriff pro Minute im selben Kampf',
  hordeStrIntAfterTime: 'Erhalte {0} Stärke und Intelligenz pro Minute im selben Kampf',
  hordeFirstAttacksCrit: 'Die ersten {0} Angriff(e) treffen garantiert kritisch',
  hordeFastKillBonusBlood: 'Erhalte +{0} Blut, wenn du den Gegner in 5 Sekunden oder weniger besiegst',
  hordeAttackPerMissingHealth: 'Erhalte +{0} Angriff pro 1% fehlende Leben',
  hordeStrIntPerMissingHealth: 'Erhalte {0} Stärke und Intelligenz pro 1% fehlende Leben',
  galleryBonusTier1Idea: '+{0} für alle Stufe-1-Ideen',
}
